import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { HTTPService } from "./../../../services/httpService";
import ScopeService from "./../../../services/scopeService";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { Modal } from 'react-bootstrap';
import CalendarCard from './calendarCard';
import CalendarGrid from './CalendarGrid';
import { ViewJob } from '../requestimates/displayJob';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import LocationService, { US_HOLIDAYS, formatHolidayDate } from './../../../services/locationService';
import ColorSettingsAPI from '../../../services/colorSettingsService';
import ColorPicker from '../../common/ColorPicker';
import { DEFAULT_STAGE_COLORS } from '../../../util/colorCodingUtils';
import TasksAPI from '../../../services/tasksService';
import TaskActionModal from '../../partial/TaskActionModal';
import { dayShare, sumCapacityDays, sumNetRevenue } from '../../../util/calendarTotals';
import { formatDuration } from '../../../util/durationDisplay';

const API = new HTTPService();

// Constants
const DESKTOP_BREAKPOINT = 1024;
const DEFAULT_CAPACITY = 8;
const DATE_FORMAT = "ddd Do MMM";

class Calendar extends Component {
    state = {
        installer: {},
        calendarDays: [],
        blockedDays: [],
        selectedDate: {},
        today: "",
        thisDay: "",
        thisWeek: "",
        thisMonth: "",
        selectedWeek: "",
        selectedMonth: "",
        startDate: "",
        duration: 0,
        range: "week", // Changed default to week for better desktop experience
        displayString: "",
        userType: this.props.userType,
        typeId: this.props.typeId,
        calendarDay: {
            calendarDate: "",
            countDraft: 0,
            countPending: 0,
            countBooked: 0
        },
        displayDays: [],
        loggedIn: false,
        // Job details popup
        showDetails: false,
        selectedRequestimate: {},
        services: {},
        notes: {},
        // Simplified sync state - only bulk
        isBulkSyncing: false,
        isDesktop: window.innerWidth >= DESKTOP_BREAKPOINT,
        expandedCards: new Set(), // Track multiple expanded cards
        error: null,
        // Calendar connection state
        isCalendarConnected: false,
        calendarConnectionError: null,
        showCalendarSelection: false,
        availableCalendars: [],
        // Technician filter state (following newFinancials pattern)
        technicians: [],
        technicianOptions: ["All Technicians"],
        selectedTechnician: "All Technicians",
        hasTechnicians: false,
        // Holidays Modal state
        showHolidaysModal: false,
        holidayBlockedDates: [],
        holidaysLoading: false,
        // Custom Closures Modal state
        showCustomClosuresModal: false,
        customClosures: [],
        newClosureStart: '',
        newClosureEnd: '',
        newClosureReason: '',
        closuresLoading: false,
        // Grid view state — grid default on desktop, cards on mobile
        viewMode: window.innerWidth >= DESKTOP_BREAKPOINT ? 'grid' : 'cards',
        // Operating hours (for closed-day detection in grid view)
        operatingHours: [],
        // Color coding state
        calendarColorMode: 'stage',
        stageColors: {},
        allStaff: [],
        showTechDropdown: false,
        // Task overlay state (in-app tasks calendar feed — separate from booking data)
        calendarTasks: [],
        calendarTaskModal: null,
    };

    async componentDidMount() {
  console.log('📱 Calendar component mounting...');
  console.log('🆔 typeId:', this.state.typeId);
            this.handleOAuthRedirect();
            
        try {
            // Get all the calendar events for the installer
            let installerRequest = `/installerLocations/${this.state.typeId}`;
            const { data: installer } = await API.get(installerRequest);

            const firstOne = installer.shift();
            this.setState({ installer: firstOne });

            // Check calendar connection status
     //       await this.checkCalendarConnection();

            // Get calendar data - only booked jobs now
            const locationId = this.props.selectedLocationId;
            const locationParam = (locationId && locationId !== 'all') ? `?locationId=${locationId}` : '';

            let calendarRequest = `/dealerCalendars/${this.state.typeId}${locationParam}`;
            const { data: dealerCalendarDays } = await API.get(calendarRequest);

            calendarRequest = `/installerCalendars/${this.state.typeId}${locationParam}`;
            const { data: installerCalendarDays } = await API.get(calendarRequest);

            var calendarDays = dealerCalendarDays.concat(installerCalendarDays);

            // Only show confirmed/active/completed work — filter by lifecycle state (currentState) and calendar slot status (workStatus)
            const validStates = ["scheduled", "received", "started", "finished", "collected"];
            calendarDays = calendarDays.filter(job => validStates.includes(job.currentState) || ["booked", "started"].includes(job.workStatus));

            calendarDays = _.orderBy(calendarDays, ['workDate'], ['asc']);

            // Filter to only show future dates
            var today = moment.utc();
            var start = moment.utc().startOf('week'); // Start with beginning of week
            var end = moment.utc().endOf('week'); // End with end of week
            
            this.setState({ 
                today,
                thisDay: moment(today), // Clone the moment object
                thisWeek: today.week(),
                selectedWeek: moment().format("w"),
                thisMonth: today.month(),
                selectedMonth: moment().format("M"),
                displayString: this.getDisplayString(start, "week"),
                startDate: start, 
                endDate: end, 
                selectedDate: moment(start), // Clone
                calendarDays
            }, () => {
                // After calendar data is loaded, set default expanded cards
                this.setDefaultExpandedCardsIfNeeded();
            });

            // Set up blocked days
            calendarRequest = `/installerBlockedCalendars/${this.state.typeId}`;
            const { data: blockedDays } = await API.get(calendarRequest);
            this.setState({ blockedDays });

        } catch (error) {
            console.error('Error loading calendar data:', error);
            this.setState({ 
                error: 'Failed to load calendar data. Please refresh the page.' 
            });
        }
// Check calendar connection status
  await this.checkCalendarConnection();

  // Handle OAuth redirect if present
  this.handleOAuthRedirect();

  // Load technicians for filter (if shop has technicians)
  await this.loadTechnicians();

  // Load blocked dates for holidays/closures management
  await this.loadBlockedDates();

  // Load operating hours (for closed weekday detection)
  await this.loadOperatingHours();

  // Load color settings
  await this.loadColorSettings();

  // Load tasks for the calendar overlay
  await this.fetchCalendarTasks();

        // Handle responsive design
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleDocumentClick);
        // Task mutations elsewhere (Tasks view, Today, funnel auto-resolve) dispatch this —
        // refetch the overlay so completed/auto-resolved chips disappear.
        window.addEventListener('refreshNavbarCounts', this.handleTasksRefresh);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleDocumentClick);
        window.removeEventListener('refreshNavbarCounts', this.handleTasksRefresh);
    }

    handleTasksRefresh = () => {
        this.fetchCalendarTasks();
    };

    handleDocumentClick = (e) => {
        if (this.state.showTechDropdown && !e.target.closest('.filter-group')) {
            this.setState({ showTechDropdown: false });
        }
    };

    handleResize = () => {
        const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
        const updates = { isDesktop };
        // Fall back to cards when going mobile (grid is desktop-only)
        if (!isDesktop && this.state.viewMode === 'grid') {
            updates.viewMode = 'cards';
        }
        this.setState(updates);
    };

    // Fetch technicians for this installer company (following newFinancials pattern)
    loadTechnicians = async () => {
        try {
            // Get users for this installer company with role = technician
            const response = await API.get(`/users?company_id=${this.state.typeId}&user_type=installer`);

            if (response.data && Array.isArray(response.data)) {
                const allStaff = response.data;
                // Always store full staff list for color lookup
                this.setState({ allStaff });

                // Build filter dropdown from all staff (any role can be assigned)
                if (allStaff.length > 0) {
                    const technicianNames = allStaff.map(s => s.user_name || s.Email);
                    const technicianOptions = ["All Technicians", ...technicianNames];

                    this.setState({
                        technicians: allStaff,
                        technicianOptions,
                        hasTechnicians: true,
                    });
                }
            }
        } catch (error) {
            console.error('Error loading technicians:', error);
            // Silently fail - technician filter just won't be available
        }
    };

    // Handle technician filter change (following newFinancials handleTypeChange pattern)
    handleTechnicianChange = (event) => {
        const { value } = event.currentTarget;
        this.setState({ selectedTechnician: value });
    };

checkCalendarConnection = async () => {
  try {
    const response = await API.get(`/installerAuth/${this.state.typeId}`);
    
    if (response.data && response.data[0]) {
      const { authenticated } = response.data[0];
      this.setState({
        isCalendarConnected: authenticated,
        calendarConnectionError: null 
      });
    } else {
      this.setState({ 
        isCalendarConnected: false,
        calendarConnectionError: 'Unable to check calendar status'
      });
    }
  } catch (error) {
    console.error('Error checking calendar status:', error);
    this.setState({ 
      isCalendarConnected: false,
      calendarConnectionError: 'Unable to check calendar status'
    });
  }
};

// Start OAuth flow from calendar page
connectCalendar = async () => {
  try {
    const locationId = this.props.selectedLocationId;
    if (!locationId || locationId === 'all') {
      alert('Please select a specific location before connecting a calendar.');
      return;
    }
    sessionStorage.setItem('calendar_page_locationId', String(locationId));
    const { data: authUrl } = await API.get(`/googlecal/auth/${this.state.typeId}?locationId=${locationId}`);
    window.location.href = authUrl;
  } catch (error) {
    console.error('Calendar connection error:', error);
    alert('Failed to connect calendar. Please try again.');
  }
};

handleOAuthRedirect = () => {
  console.log('🔍 handleOAuthRedirect called');
  console.log('🔍 Current URL:', window.location.href);
  console.log('🔍 Search params:', window.location.search);
  
  const urlParams = new URLSearchParams(window.location.search);
  
  // Log all URL parameters
  for (let [key, value] of urlParams.entries()) {
    console.log(`🔗 URL param: ${key} = ${value}`);
  }
  
  if (urlParams.get('calendar_selection')) {
    console.log('✅ Calendar selection parameter found');
    try {
      const calendarsParam = urlParams.get('calendars');
      const installerId = urlParams.get('installer_id');
      
      console.log('📄 Raw calendars param:', calendarsParam);
      console.log('🆔 Installer ID from URL:', installerId);
      console.log('🆔 Current typeId:', this.state.typeId);
      
      const calendars = JSON.parse(calendarsParam);
      console.log('📅 Parsed calendars:', calendars);
      console.log('📊 Number of calendars:', calendars.length);
      
      if (installerId === this.state.typeId.toString()) {
        // Read location_id from redirect URL, fallback to sessionStorage
        const locationId = urlParams.get('location_id') || sessionStorage.getItem('calendar_page_locationId');
        sessionStorage.removeItem('calendar_page_locationId');

        this.setState({
          showCalendarSelection: true,
          availableCalendars: calendars,
          calendarSelectionLocationId: locationId ? Number(locationId) || locationId : null
        });
      }
      
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (e) {
      console.error('❌ Error parsing calendar list:', e);
      alert('Error loading calendar options. Please try again.');
    }
  } else {
    console.log('ℹ️ No calendar_selection parameter found');
  }
};


handleCalendarSelection = async (selectedCalendar) => {
  try {
    await API.post('/googlecal/select', {
      installerId: this.state.typeId,
      calendarId: selectedCalendar.id,
      locationId: this.state.calendarSelectionLocationId
    });
    
    this.setState({ 
      showCalendarSelection: false,
      availableCalendars: [],
      isCalendarConnected: true
    });
    
    // Refresh navbar status
    window.dispatchEvent(new CustomEvent('calendarStatusChanged', { detail: { connected: true } }));
    
    alert(`Calendar "${selectedCalendar.name}" connected successfully!`);
  } catch (error) {
    console.error('Error saving calendar selection:', error);
    alert('Failed to save calendar selection. Please try again.');
  }
};

    getDisplayString = (date, range, serviceCount = 0) => {
        let dateString = "";
        if (range === "day") {
            dateString = date.format("ddd, MMM Do YYYY");
        } else if (range === "week") {
            const startOfWeek = moment(date).startOf("week");
            const endOfWeek = moment(date).endOf("week");
            dateString = startOfWeek.format("MMM Do") + " - " + endOfWeek.format("MMM Do, YYYY");
        } else if (range === "month") {
            const startOfMonth = moment(date).startOf("month");
            const endOfMonth = moment(date).endOf("month");
            dateString = startOfMonth.format("MMM Do") + " - " + endOfMonth.format("MMM Do, YYYY");
        } else {
            dateString = date.format("ddd, MMM Do YYYY");
        }
        
        if (serviceCount > 0) {
            return `${dateString} (${serviceCount} service${serviceCount !== 1 ? 's' : ''})`;
        }
        return dateString;
    };

    getPeriodRevenueLabel = () => {
        switch(this.state.range) {
            case 'day': return 'Day Revenue';
            case 'week': return 'Week Revenue'; 
            case 'month': return 'Month Revenue';
            default: return 'Period Revenue';
        }
    };

    handleClick = (event) => {
        const { value } = event.currentTarget;
        this.setState({ selectedDate: value });
    };

    navigate = async (url) => {
        window.location.href = url;
    }

    // Display job details when card is clicked
    displayDetails = async (requestId) => {
        try {
            let dispRequest = `/requestimates/fullrequest/?Id=${requestId}`;
            const { data: selectedRequests } = await API.get(dispRequest);

            let servicesRequest = `/requestservice/${requestId}`;
            const { data: services } = await API.get(servicesRequest);

            let notesRequest = `/requestnotes/${requestId}`;
            const { data: notes } = await API.get(notesRequest);

            this.setState({
                selectedRequestimate: selectedRequests[0],
                services,
                notes,
                showDetails: true
            });
        } catch (error) {
            console.error('Error loading job details:', error);
            alert('Error loading job details. Please try again.');
        }
    }

    addCustomClose = () => {
        this.setState({ showDetails: false });
    };

    // SIMPLIFIED: Only bulk sync now
    handleBulkSync = async () => {
        const unsyncedJobs = this.getUnsyncedJobs();
        
        if (unsyncedJobs.length === 0) {
            alert('All services are already synced to calendar.');
            return;
        }

        const message = `Add ${unsyncedJobs.length} unsynced services to Google Calendar?\n\nThis will create calendar events for all jobs from today forward that aren't already synced.`;
        
        if (!window.confirm(message)) {
            return;
        }

        this.setState({ isBulkSyncing: true });

        let successCount = 0;
        let errorCount = 0;
        let authError = false;
        
        // Process jobs in batches to avoid overwhelming the API
        const batchSize = 5;
        for (let i = 0; i < unsyncedJobs.length; i += batchSize) {
            const batch = unsyncedJobs.slice(i, i + batchSize);
            
            // eslint-disable-next-line no-loop-func
            const batchPromises = batch.map(async (job) => {
                try {
                    const appointmentData = {
                        request: job.requestId,
                        summary: job.workString,
                        description: "",
                        colorId: "6",
                        installerId: this.state.typeId
                    };
                    
                    const response = await API.put('/addAppt/', appointmentData);
                    
                    if (response.data && response.data.success) {
                        successCount++;
                    } else {
                        throw new Error(response.data?.error || 'Unknown error');
                    }
                    
                    // Small delay between requests in batch
                    await new Promise(resolve => setTimeout(resolve, 200));
                    
                } catch (error) {
                    console.error(`Failed to sync job ${job.requestId}:`, error);
                    
                    // Check for auth errors
                    if (error.response?.status === 401 || 
                        error.message?.includes('expired') || 
                        error.message?.includes('invalid_grant')) {
                        authError = true;
                    }
                    
                    errorCount++;
                }
            });
            
            await Promise.allSettled(batchPromises);
            
            // If we hit auth errors, stop processing
            if (authError) {
                break;
            }
            
            // Delay between batches
            if (i + batchSize < unsyncedJobs.length) {
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }

        this.setState({ isBulkSyncing: false });
        
        // Handle auth errors
        if (authError) {
            this.setState({ 
                isCalendarConnected: false,
                calendarConnectionError: 'Calendar connection expired'
            });
            
            alert('Your Google Calendar connection has expired. Please reconnect your calendar and try again.');
            return;
        }
        
        // Show results
        let resultMessage = `Bulk sync completed!\n\n`;
        resultMessage += `✅ Successfully synced: ${successCount} services\n`;
        
        if (errorCount > 0) {
            resultMessage += `❌ Failed to sync: ${errorCount} services\n\n`;
            resultMessage += `They can be synced individually by trying the bulk sync again.`;
        }
        
        alert(resultMessage);
        
        // Refresh calendar data to show updated sync status
        await this.refreshCalendarData();
    };

    getUnsyncedJobs = () => {
        // Get jobs from today forward that don't have calendar events
        const today = moment().startOf('day');
        
        return this.state.calendarDays
            .filter(job => {
                // workDate is a DATE column — use moment.utc to preserve the
                // stored calendar date regardless of viewer's browser TZ.
                const jobDate = moment.utc(job.workDate);
                return jobDate.isSameOrAfter(today) && !job.eventId;
            })
            .map(job => ({
                requestId: job.requestId,
                serviceId: job.serviceId,
                workString: job.category + " - " + job.description + " on " +
                           job.year + " " + job.make + " " + job.model + " " +
                           job.trim + " for " + job.dealerName
            }));
    };

    refreshCalendarData = async () => {
        try {
            // Re-fetch calendar data to get updated sync status
            const locationId = this.props.selectedLocationId;
            const locationParam = (locationId && locationId !== 'all') ? `?locationId=${locationId}` : '';

            let calendarRequest = `/dealerCalendars/${this.state.typeId}${locationParam}`;
            const { data: dealerCalendarDays } = await API.get(calendarRequest);

            calendarRequest = `/installerCalendars/${this.state.typeId}${locationParam}`;
            const { data: installerCalendarDays } = await API.get(calendarRequest);

            var calendarDays = dealerCalendarDays.concat(installerCalendarDays);
            const validStates = ["scheduled", "received", "started", "finished", "collected"];
            calendarDays = calendarDays.filter(job => validStates.includes(job.currentState) || ["booked", "started"].includes(job.workStatus));
            calendarDays = _.orderBy(calendarDays, ['workDate'], ['asc']);

            this.setState({ calendarDays });
        } catch (error) {
            console.error('Error refreshing calendar data:', error);
        }

        this.fetchCalendarTasks();
    };

    // ---- Task overlay (in-app tasks calendar feed) ----
    // Tasks render as an overlay layer on the calendar — they never touch
    // calendarDays (booking data), capacity, revenue, or Google-sync counts.

    // Fetch window for GET /api/tasks/calendar. Month view uses the grid's
    // padded cell range (leading/trailing outside-month days) so edge-week
    // chips aren't missing.
    getTaskCalendarWindow = () => {
        const start = moment(this.state.startDate || this.state.today);
        if (!start.isValid()) return null;
        if (this.state.range === 'month') {
            return {
                start: moment(start).startOf('month').startOf('week'),
                end: moment(start).endOf('month').endOf('week'),
            };
        }
        const end = moment(this.state.endDate || start);
        return { start: moment(start).startOf('day'), end: moment(end).endOf('day') };
    };

    fetchCalendarTasks = async () => {
        try {
            const win = this.getTaskCalendarWindow();
            if (!win) return;
            const locationId = this.props.selectedLocationId;
            const params = {
                installerId: this.state.typeId,
                start: win.start.format('YYYY-MM-DD'),
                end: win.end.format('YYYY-MM-DD'),
                userId: ScopeService.getUserId(),
                userRole: ScopeService.getUserRole(),
            };
            if (locationId && locationId !== 'all') params.locationId = locationId;
            const tasks = await TasksAPI.getCalendar(params);
            this.setState({ calendarTasks: Array.isArray(tasks) ? tasks : [] });
        } catch (error) {
            // Never block job rendering on the task overlay
            console.error('Error loading calendar tasks:', error);
            this.setState({ calendarTasks: [] });
        }
    };

    // Map calendar tasks to chip view-objects shaped like buildDisplayWorkTable
    // entries (viewKey/startDate/startDateString/start_time/end_time) with an
    // isTask discriminator. Consultations time-anchor at reminder_at (+30 min)
    // when inside the grid's 8 AM–6 PM span; everything else is an all-day chip.
    buildTaskChips = () => {
        const { calendarTasks } = this.state;
        if (!Array.isArray(calendarTasks) || calendarTasks.length === 0) return [];
        const win = this.getTaskCalendarWindow();
        if (!win) return [];

        const chips = [];
        calendarTasks.forEach(task => {
            let dateStr = null;
            let startTime = null;
            let endTime = null;

            if (task.task_type === 'consultation' && task.reminder_at) {
                const rm = moment(task.reminder_at, 'YYYY-MM-DD HH:mm');
                if (rm.isValid()) {
                    dateStr = rm.format('YYYY-MM-DD');
                    const hour = rm.hour() + rm.minute() / 60;
                    // Outside grid hours → fall back to all-day chip
                    if (hour >= 8 && hour + 0.5 <= 18) {
                        startTime = rm.format('HH:mm');
                        endTime = moment(rm).add(30, 'minutes').format('HH:mm');
                    }
                }
            }
            if (!dateStr && task.due_date) {
                dateStr = String(task.due_date).substring(0, 10);
            }
            if (!dateStr) return; // no usable date

            const day = moment(dateStr);
            if (!day.isBetween(win.start, win.end, null, '[]')) return;

            chips.push({
                isTask: true,
                task,
                viewKey: `task-${task.task_id}`,
                startDate: dateStr,
                startDateString: day.format(DATE_FORMAT),
                start_time: startTime,
                end_time: endTime,
                snoozed: task.status === 'snoozed',
            });
        });
        return chips;
    };

    handleTaskClick = (task) => {
        this.setState({ calendarTaskModal: task });
    };

    handleTaskActionComplete = () => {
        this.setState({ calendarTaskModal: null });
        this.fetchCalendarTasks();
    };


disconnectCalendar = async () => {
  if (!window.confirm('Are you sure you want to disconnect your Google Calendar? This will stop syncing jobs to your calendar.')) {
    return;
  }

  try {
    const locationId = this.props.selectedLocationId;
    if (!locationId || locationId === 'all') {
      alert('Please select a specific location before disconnecting a calendar.');
      return;
    }
    await API.delete(`/googlecal/disconnect/${this.state.typeId}?locationId=${locationId}`);
    
    this.setState({ 
      isCalendarConnected: false,
      calendarConnectionError: null 
    });
    
    // Refresh navbar status
    window.dispatchEvent(new CustomEvent('calendarStatusChanged', { detail: { connected: false } }));
    
    alert('Calendar disconnected successfully. You can reconnect anytime.');
  } catch (error) {
    console.error('Calendar disconnection error:', error);
    alert('Failed to disconnect calendar. Please try again.');
  }
};


// FIXED: Moment.js mutability issues
    handleDisplayRange = (event) => {
        const { value } = event.currentTarget;
        var newDay = moment(this.state.selectedDate || this.state.today); // Already cloned
        var displayString = "";
        var endDate;

        if (this.state.range === "day") {
            if (value === "today") {
                newDay = moment(); // Create new moment
            }
            if (value === "less") {
                newDay = moment(newDay).subtract(1, "day"); // Clone before mutating
            }
            if (value === "more") {
                newDay = moment(newDay).add(1, "day"); // Clone before mutating
            }
            endDate = moment(newDay); // Clone for endDate
        }

        if (this.state.range === "week") {
            if (value === "today") {
                newDay = moment().startOf("week"); // Create new moment
            }
            if (value === "less") {
                newDay = moment(newDay).subtract(1, "week").startOf("week"); // Clone first
            }
            if (value === "more") {
                newDay = moment(newDay).add(1, "week").startOf("week"); // Clone first
            }
            endDate = moment(newDay).endOf("week"); // Clone for endDate
        }

        if (this.state.range === "month") {
            if (value === "today") {
                newDay = moment().startOf("month"); // Create new moment
            }
            if (value === "less") {
                newDay = moment(newDay).subtract(1, "month").startOf("month"); // Clone first
            }
            if (value === "more") {
                newDay = moment(newDay).add(1, "month").startOf("month"); // Clone first
            }
            endDate = moment(newDay).endOf("month"); // Clone for endDate
        }

        displayString = this.getDisplayString(newDay, this.state.range);

        this.setState({ selectedDate: newDay, startDate: newDay, endDate, displayString }, () => {
            this.fetchCalendarTasks();
        });
    };

    handleRange = (event) => {
        const { value } = event.currentTarget;
        var displayString = "";
        var newDay = moment(this.state.selectedDate || this.state.today);
        var endDate = "";

        if (value === "week") {
            newDay = moment(newDay).startOf('week'); // Clone first
            endDate = moment(newDay).endOf('week'); // Clone for endDate
        }
        if (value === "month") {
            newDay = moment(newDay).startOf('month'); // Clone first
            endDate = moment(newDay).endOf('month'); // Clone for endDate
        }
        if (value === "day") {
            endDate = moment(newDay); // Clone for endDate
        }

        displayString = this.getDisplayString(newDay, value);
        this.setState({ range: value, selectedDate: newDay, startDate: newDay, endDate, displayString }, () => {
            this.fetchCalendarTasks();
        });
    };

    // UPDATED: Handle multiple card expansion
    handleCardExpansion = (dateString) => {
        const { expandedCards } = this.state;
        const newExpandedCards = new Set(expandedCards);
        
        // Toggle the card - if it's expanded, collapse it; if collapsed, expand it
        if (newExpandedCards.has(dateString)) {
            newExpandedCards.delete(dateString);
        } else {
            newExpandedCards.add(dateString);
        }
        
        this.setState({ 
            expandedCards: newExpandedCards
        });
    };

    // NEW: Set default expanded state for today's card (called after data loads)
    setDefaultExpandedCardsIfNeeded = () => {
        // Only set defaults if no cards are currently expanded
        if (this.state.expandedCards.size === 0) {
            // Build the unique days list same as in render
            const displayWorkTable = this.buildDisplayWorkTable();
            let uniqueDays = displayWorkTable.map(i => i.startDateString);
            const uniques = Array.from(new Set(uniqueDays));
            
            const todayString = moment().format(DATE_FORMAT);
            
            // If today's date exists in the unique dates, expand it by default
            if (uniques.includes(todayString)) {
                this.setState({ 
                    expandedCards: new Set([todayString])
                });
            }
        }
    };

    // Helper method to build display work table (extracted from render)
    buildDisplayWorkTable = () => {
        const { calendarDays, selectedTechnician, allStaff: technicians } = this.state;

        // Filter and prepare display data
        var startDate = moment(this.state.startDate || this.state.today).startOf("day");
        var endDate = moment(this.state.endDate || startDate).endOf("day");

        // Make sure both are valid moment objects
        if (!startDate.isValid() || !endDate.isValid()) {
            return [];
        }

        let displayWorkTable = [];

        for (let i = 0; i < calendarDays.length; i++) {
            const appointment = calendarDays[i];
            const jobDuration = Math.max(Math.ceil(appointment.duration || 1), 1); // At least 1 full day
            const startMoment = moment(appointment.workDate);

            // Get assigned technician info — prefer server-provided fields, fall back to staff lookup
            const techId = appointment.assignedTechnicianId || appointment.assigned_technician_id || null;
            let assignedTechnicianName = appointment.assignedTechnicianName || null;
            let assignedTechnicianColor = appointment.assignedTechnicianColor || null;
            if (techId && !assignedTechnicianName && Array.isArray(technicians)) {
                const assignedTech = technicians.find(t => String(t.User_id) === String(techId));
                if (assignedTech) {
                    assignedTechnicianName = assignedTech.user_name || assignedTech.Email;
                    assignedTechnicianColor = assignedTechnicianColor || assignedTech.user_color || null;
                }
            }

            // Apply technician filter - matches the lead OR any step assignee under that tech.
            if (selectedTechnician !== "All Technicians") {
                const leadMatches = assignedTechnicianName === selectedTechnician;
                const stepMatches = Array.isArray(appointment.tech_assignment?.techs)
                    && appointment.tech_assignment.techs.some(t => t && t.name === selectedTechnician);
                if (!leadMatches && !stepMatches) {
                    continue;
                }
            }

            // Use actual work dates from server if available, fall back to consecutive expansion
            const actualDates = appointment.workDates && appointment.workDates.length > 0
                ? appointment.workDates.map(d => moment(d).format('YYYY-MM-DD'))
                : Array.from({ length: jobDuration }, (_, i) => moment(startMoment).add(i, 'days').format('YYYY-MM-DD'));

            actualDates.forEach((dateStr, idx) => {
                const currentDay = moment(dateStr);

                if (currentDay.isBetween(startDate, endDate, null, '[]')) {
                    const view = {
                        viewKey: appointment.requestId.toString() + appointment.serviceId.toString() + dateStr,
                        requestType: appointment.requestType,
                        requestId: appointment.requestId,
                        serviceId: appointment.serviceId,
                        startDate: dateStr,
                        startDateString: currentDay.format(DATE_FORMAT),
                        dueDate: appointment.dueDate,
                        dueDateString: moment(appointment.dueDate).format(DATE_FORMAT),
                        workString: appointment.category + " - " + appointment.description + " on " + appointment.year + " " +
                            appointment.make + " " + appointment.model + " " + appointment.trim + " for " +
                            appointment.dealerName,
                        // WHOLE-JOB duration — the same on every day's view.
                        estimate: appointment.duration,
                        // THIS day's share of it. Anything summing across the
                        // work table must use this, or a 3-day job counts as 9.
                        dayShare: dayShare(appointment.duration, actualDates.length),
                        eventId: appointment.eventId,
                        isInCalendar: !!appointment.eventId,
                        // Multi-day job properties
                        currentDay: idx + 1,
                        totalDays: actualDates.length,
                        isMultiDay: actualDates.length > 1,
                        originalWorkDate: appointment.workDate,
                        // Technician assignment info
                        assignedTechnicianId: techId,
                        assignedTechnicianName: assignedTechnicianName,
                        assignedTechnicianColor: assignedTechnicianColor,
                        tech_assignment: appointment.tech_assignment || null,
                        // Location info
                        location_id: appointment.location_id,
                        locationName: appointment.locationName || appointment.location_name,
                        // Mobile-mode time fields — populated for installer_calendar
                        // rows scheduled through the mobile scheduler. Used by
                        // CalendarGrid to position the block by actual time-of-day.
                        // Null for fixed-shop / multi-day jobs → CalendarGrid falls
                        // back to flex-stacked rendering.
                        start_time: appointment.start_time || null,
                        end_time: appointment.end_time || null,
                        // Parsed fields for grid/popover (avoids re-parsing workString)
                        category: appointment.category || '',
                        serviceDescription: appointment.customDescription || appointment.description || '',
                        vehicleYear: appointment.year || '',
                        vehicleMake: appointment.make || '',
                        vehicleModel: appointment.model || '',
                        vehicleTrim: appointment.trim || '',
                        // Carried solely so the calendar can mark a boat. The BT
                        // prefix is the only reliable asset-type signal — a boat
                        // has no trim or body style to key off, and the service
                        // description ("Marine Hull Sides PPF") is installer-
                        // chosen text, not an asset type.
                        //
                        // Added to /dealerCalendars and /installerCalendars on
                        // 2026-08-06; before that the payload carried 37 fields
                        // and none identified the asset. See
                        // tasks/server-prompt-calendar-vin.md.
                        vin: appointment.vin || appointment.VIN || appointment.Vin || '',
                        customerName: appointment.dealerName || '',
                        dealerName: appointment.dealerName || '',
                        workStatus: appointment.workStatus || '',
                        currentState: appointment.currentState || '',
                        serviceAmount: appointment.serviceAmount || 0,
                        serviceDiscount: appointment.serviceDiscount || 0,
                    };
                    displayWorkTable.push(view);
                }
            });
        }

        return displayWorkTable;
    };

    authorizeGoogle = async () => {
        try {
            let userSetup = `/request`;        
            const { data: creds } = await API.get(userSetup);
            this.navigate(creds);
        } catch (error) {
            console.error('Error authorizing Google:', error);
            alert('Error connecting to Google Calendar. Please try again.');
        }
    };

    getVisibleJobCount = (displayWorkTable) => {
        // Count unique jobs in current view only
        const visibleJobIds = new Set(displayWorkTable.map(item => item.requestId));
        return visibleJobIds.size;
    };

    // FIXED: Revenue calculation with discount subtraction
    getVisibleRevenue = (displayWorkTable) => {
        // Calculate revenue for visible services only, subtracting discounts
        // One view per DAY — so a 3-day job appears three times. Count each
        // service line once, or its revenue is tripled.
        return sumNetRevenue(displayWorkTable, (item) =>
            this.state.calendarDays.find(
                appt => appt.requestId === item.requestId && appt.serviceId === item.serviceId
            )
        );
    };

    getVisibleCapacityUtilization = (displayWorkTable) => {
        // Calculate capacity for visible period only
        const dailyCapacity = this.state.installer.capacity || DEFAULT_CAPACITY;
        // Per-day shares, not the whole-job duration once per day. Also means a
        // job crossing the week boundary contributes only its visible days.
        const totalDays = sumCapacityDays(displayWorkTable);
        
        // Calculate available capacity based on date range
        const startDate = moment(this.state.startDate || this.state.today).startOf('day');
        const endDate = moment(this.state.endDate || startDate).endOf('day');
        const periodDays = endDate.diff(startDate, 'days') + 1;
        const availableCapacity = dailyCapacity * periodDays;
        
        return availableCapacity > 0 ? Math.round((totalDays / availableCapacity) * 100) : 0;
    };

    // Export week schedule as PDF using existing jsPDF and html2canvas
    exportWeekSchedule = async () => {
        // Only allow export when week view is selected
        if (this.state.range !== "week") {
            alert("Export is only available in Week view. Please switch to Week view first.");
            return;
        }

        this.setState({ loading: true });

        try {
            // Get the current week's start and end dates
            const startDate = moment(this.state.startDate).startOf('day');
            const endDate = moment(this.state.endDate).endOf('day');
            
            // Prepare data for the week
            const weekData = this.prepareWeekData(startDate, endDate);
            
            // Create a temporary hidden div with the schedule content
            // theme-ignore-start — print document: colours are literal and always light
            const tempScheduleDiv = document.createElement('div');
            tempScheduleDiv.setAttribute('data-theme', 'light'); // PDFs are always light
            tempScheduleDiv.id = 'temp-schedule-for-pdf';
            tempScheduleDiv.style.position = 'absolute';
            tempScheduleDiv.style.left = '-9999px';
            tempScheduleDiv.style.top = '-9999px';
            tempScheduleDiv.style.width = '800px';
            tempScheduleDiv.style.backgroundColor = 'white';
            tempScheduleDiv.style.padding = '30px';
            tempScheduleDiv.style.fontFamily = 'Arial, sans-serif';

            // Days of the week
            const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            
            // Build the simple schedule HTML
            let scheduleHTML = `
                <div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4; color: #333;">
                    <!-- Header -->
                    <div style="text-align: center; margin-bottom: 25px; border-bottom: 2px solid #3FB2BE; padding-bottom: 15px;">
                        <h1 style="font-size: 22px; font-weight: bold; margin: 0 0 5px 0; color: #2c3e50;">Work Schedule</h1>
                        <h2 style="font-size: 14px; color: #3FB2BE; margin: 0;">${startDate.format('MMM Do')} - ${endDate.format('MMM Do, YYYY')}</h2>
                    </div>
                    
                    <!-- Simple Table -->
                    <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
                        <thead>
                            <tr style="background-color: #3FB2BE; color: white;">
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left; font-weight: bold; width: 15%;">Day</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left; font-weight: bold; width: 35%;">Vehicle</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left; font-weight: bold; width: 50%;">Service</th>
                            </tr>
                        </thead>
                        <tbody>
            `;

            // Generate table rows for each day
            daysOfWeek.forEach((dayName, index) => {
                const dayMoment = moment(startDate).add(index, 'days');
                const dayKey = dayMoment.format('YYYY-MM-DD');
                const dayJobs = weekData[dayKey] || [];
                
                if (dayJobs.length === 0) {
                    // Empty day row
                    scheduleHTML += `
                        <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                            <td style="border: 1px solid #ddd; padding: 8px; font-weight: bold; color: #3FB2BE;">
                                ${dayName}<br><span style="font-size: 10px; font-weight: normal; color: #666;">${dayMoment.format('MMM Do')}</span>
                            </td>
                            <td style="border: 1px solid #ddd; padding: 8px; color: #999; font-style: italic;" colspan="2">
                                No scheduled services
                            </td>
                        </tr>
                    `;
                } else {
                    // First job with day name
                    const firstJob = dayJobs[0];
                    scheduleHTML += `
                        <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                            <td style="border: 1px solid #ddd; padding: 8px; font-weight: bold; color: #3FB2BE; vertical-align: top;">
                                ${dayName}<br><span style="font-size: 10px; font-weight: normal; color: #666;">${dayMoment.format('MMM Do')}</span>
                            </td>
                            <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                ${firstJob.vehicleInfo}
                            </td>
                            <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                ${firstJob.serviceInfo}
                                ${firstJob.estimate ? `<span style="color: #666; font-size: 10px;"> (${formatDuration(firstJob.estimate)})</span>` : ''}
                            </td>
                        </tr>
                    `;
                    
                    // Additional jobs for the same day (without day name)
                    for (let i = 1; i < dayJobs.length; i++) {
                        const job = dayJobs[i];
                        scheduleHTML += `
                            <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                                <td style="border: 1px solid #ddd; padding: 8px;"></td>
                                <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                    ${job.vehicleInfo}
                                </td>
                                <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
                                    ${job.serviceInfo}
                                    ${job.estimate ? `<span style="color: #666; font-size: 10px;"> (${formatDuration(job.estimate)})</span>` : ''}
                                </td>
                            </tr>
                        `;
                    }
                }
            });

            // Close table and add footer
            scheduleHTML += `
                        </tbody>
                    </table>
                    
                    <!-- Footer -->
                    <div style="margin-top: 20px; text-align: center; color: #666; font-size: 10px; border-top: 1px solid #ddd; padding-top: 10px;">
                        Generated on ${moment().format('MMM Do, YYYY at h:mm A')}
                    </div>
                </div>
            `;

            tempScheduleDiv.innerHTML = scheduleHTML;

            // Add to DOM temporarily
            document.body.appendChild(tempScheduleDiv);
            // theme-ignore-end

            // Generate the canvas from the temporary div
            const canvas = await html2canvas(tempScheduleDiv, { 
                scale: 1.5, // Reduced scale for better performance
                useCORS: true,
                backgroundColor: '#ffffff', // theme-ignore-line — html2canvas option, not CSS
                logging: false,
                width: 800,
                height: tempScheduleDiv.scrollHeight
            });
            
            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");
            
            // Calculate dimensions to fit the page better
            const imgWidth = 190; // A4 width minus margins
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            
            // Add the image to PDF (should fit on single page with simplified layout)
            pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

            // Generate filename
            const filename = `work-schedule-${startDate.format('YYYY-MM-DD')}-to-${endDate.format('YYYY-MM-DD')}.pdf`;
            
            // Download the PDF
            pdf.save(filename);

            // Clean up - remove the temporary div
            if (document.body.contains(tempScheduleDiv)) {
                document.body.removeChild(tempScheduleDiv);
            }

            this.setState({ loading: false });

        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Error generating PDF export. Please try again.');
            this.setState({ loading: false });
        }
    };

    // Helper method to prepare week data
    prepareWeekData = (startDate, endDate) => {
        const weekData = {};
        
        // Get all jobs for the current week from displayWorkTable logic
        const { calendarDays } = this.state;
        
        for (let i = 0; i < calendarDays.length; i++) {
            const appointment = calendarDays[i];
            const jobDuration = Math.max(Math.ceil(appointment.duration || 1), 1);
            // workDate is a DATE column — mysql2 returns it as a JS Date at
            // UTC midnight. Use moment.utc() so the stored date is preserved
            // regardless of viewer's browser TZ (otherwise EDT viewers see
            // HST-stored May 14 as May 13).
            const startMoment = moment.utc(appointment.workDate);

            // Use actual work dates from server if available, fall back to consecutive expansion
            const actualDates = appointment.workDates && appointment.workDates.length > 0
                ? appointment.workDates.map(d => moment.utc(d).format('YYYY-MM-DD'))
                : Array.from({ length: jobDuration }, (_, i) => moment.utc(startMoment).add(i, 'days').format('YYYY-MM-DD'));

            actualDates.forEach((dateStr, idx) => {
                const currentDay = moment(dateStr);

                if (currentDay.isBetween(startDate, endDate, null, '[]')) {
                    const dayKey = dateStr;

                    if (!weekData[dayKey]) {
                        weekData[dayKey] = [];
                    }

                    // Parse the work string to get vehicle and service info
                    const { customerName, serviceName, vehicleInfo } = this.parseJobInfoForExport(appointment);

                    // Build service description
                    let serviceDescription = serviceName;
                    if (actualDates.length > 1) {
                        serviceDescription += ` (Day ${idx + 1} of ${actualDates.length})`;
                    }

                    // Add customer info if available
                    if (customerName && customerName !== 'Customer') {
                        serviceDescription += ` - ${customerName}`;
                    }

                    weekData[dayKey].push({
                        vehicleInfo: vehicleInfo,
                        serviceInfo: serviceDescription,
                        requestId: appointment.requestId,
                        serviceId: appointment.serviceId,
                        dueDate: appointment.dueDate,
                        estimate: appointment.duration,
                        requestType: appointment.requestType,
                        location_id: appointment.location_id,
                        locationName: appointment.locationName || appointment.location_name
                    });
                }
            });
        }
        
        return weekData;
    };

    // Helper method to parse job info for export
    parseJobInfoForExport = (appointment) => {
        try {
            // Build the work string like in the main component
            const workString = appointment.category + " - " + appointment.description + " on " +
                appointment.year + " " + appointment.make + " " + appointment.model + " " +
                appointment.trim + " for " + appointment.dealerName;

            const forIndex = workString.lastIndexOf(' for ');
            const onIndex = workString.indexOf(' on ');

            let customerName = appointment.dealerName || 'Customer';
            let serviceName = appointment.category + " - " + appointment.description;
            let vehicleInfo = 'Vehicle info not available';

            if (forIndex > -1) {
                customerName = workString.substring(forIndex + 5).trim();
            }

            if (onIndex > -1 && onIndex < forIndex) {
                const vehicleAndDealer = workString.substring(onIndex + 4, forIndex).trim();
                vehicleInfo = vehicleAndDealer;
            } else if (appointment.year && appointment.make && appointment.model) {
                // Fallback to building vehicle info from individual fields
                vehicleInfo = `${appointment.year} ${appointment.make} ${appointment.model}`;
                if (appointment.trim) {
                    vehicleInfo += ` ${appointment.trim}`;
                }
            }

            return { customerName, serviceName, vehicleInfo };
        } catch (error) {
            console.error('Error parsing job info for export:', error);
            return {
                customerName: appointment.dealerName || 'Customer',
                serviceName: appointment.category + " - " + appointment.description,
                vehicleInfo: 'Vehicle info not available'
            };
        }
    };

    // ==================== BLOCKED DATES / HOLIDAYS / CLOSURES ====================

    loadBlockedDates = async () => {
        try {
            // Use selected location for blocked dates, falling back to typeId for single-location
            const locationId = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
              ? this.props.selectedLocationId : this.state.typeId;
            const data = await LocationService.getBlockedDates(locationId);
            const blockedDates = data.blockedDates || [];

            // Separate holiday dates from custom closures
            // Holiday dates will be identified by checking if they match a known holiday date
            const currentYear = moment().year();
            const nextYear = currentYear + 1;

            // Get all holiday dates for current and next year
            const holidayDatesSet = new Set();
            US_HOLIDAYS.forEach(holiday => {
                holidayDatesSet.add(holiday.getDate(currentYear));
                holidayDatesSet.add(holiday.getDate(nextYear));
            });

            // Filter: dates that match holiday dates are holiday blocks
            const holidayBlockedDates = blockedDates.filter(bd => holidayDatesSet.has(bd.date));

            // Filter: dates that don't match holidays are custom closures
            // Group consecutive dates with same reason as date ranges
            const nonHolidayDates = blockedDates.filter(bd => !holidayDatesSet.has(bd.date));
            const customClosures = this.groupIntoClosure(nonHolidayDates);

            this.setState({
                holidayBlockedDates,
                customClosures
            });
        } catch (error) {
            console.error('Error loading blocked dates:', error);
        }
    };

    loadOperatingHours = async () => {
        try {
            const locationId = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
                ? this.props.selectedLocationId : this.state.typeId;
            const data = await LocationService.getOperatingHours(locationId);
            this.setState({ operatingHours: data.hours || data || [] });
        } catch (error) {
            console.error('Error loading operating hours:', error);
        }
    };

    loadColorSettings = async () => {
        try {
            const data = await ColorSettingsAPI.getColorSettings(this.state.typeId);
            let mode = data.calendar_color_mode || 'stage';
            // If saved as technician mode but no techs have colors, fall back to stage
            if (mode === 'technician' && !(this.state.allStaff || []).some(t => t.user_color)) {
                mode = 'stage';
            }
            this.setState({
                calendarColorMode: mode,
                stageColors: data.stage_colors || {},
            });
        } catch (error) {
            // Silently fail — defaults are fine
        }
    };

    handleColorModeToggle = async (mode) => {
        this.setState({ calendarColorMode: mode });
        try {
            await ColorSettingsAPI.updateColorSettings(this.state.typeId, { calendar_color_mode: mode });
        } catch (error) {
            console.error('Error saving color mode:', error);
        }
    };

    handleStageColorChange = async (stage, color) => {
        const stageColors = { ...this.state.stageColors, [stage]: color };
        if (!color) delete stageColors[stage];
        this.setState({ stageColors });
        try {
            await ColorSettingsAPI.updateColorSettings(this.state.typeId, { stage_colors: stageColors });
        } catch (error) {
            console.error('Error saving stage color:', error);
        }
    };

    // Group blocked dates into closures (date ranges with same reason)
    groupIntoClosure = (blockedDates) => {
        if (!blockedDates.length) return [];

        // Sort by date
        const sorted = [...blockedDates].sort((a, b) => a.date.localeCompare(b.date));
        const closures = [];
        let currentClosure = null;

        for (const bd of sorted) {
            if (!currentClosure) {
                currentClosure = {
                    start_date: bd.date,
                    end_date: bd.date,
                    reason: bd.reason
                };
            } else {
                // Check if this date is consecutive and has the same reason
                const prevDate = moment.utc(currentClosure.end_date).local();
                const currDate = moment.utc(bd.date).local();
                const daysDiff = currDate.diff(prevDate, 'days');

                if (daysDiff === 1 && bd.reason === currentClosure.reason) {
                    // Extend current closure
                    currentClosure.end_date = bd.date;
                } else {
                    // Start a new closure
                    closures.push(currentClosure);
                    currentClosure = {
                        start_date: bd.date,
                        end_date: bd.date,
                        reason: bd.reason
                    };
                }
            }
        }

        // Don't forget the last one
        if (currentClosure) {
            closures.push(currentClosure);
        }

        return closures;
    };

    // Format a date range for display
    formatDateRange = (startDate, endDate) => {
        const start = moment(startDate);
        const end = moment(endDate);

        if (start.isSame(end, 'day')) {
            return start.format('ddd, MMM D, YYYY');
        }

        if (start.isSame(end, 'year')) {
            return `${start.format('ddd, MMM D')} - ${end.format('ddd, MMM D, YYYY')}`;
        }

        return `${start.format('ddd, MMM D, YYYY')} - ${end.format('ddd, MMM D, YYYY')}`;
    };

    // ---- Holidays Modal Methods ----
    handleOpenHolidaysModal = () => {
        this.setState({ showHolidaysModal: true });
    };

    handleCloseHolidaysModal = () => {
        this.setState({ showHolidaysModal: false });
    };

    // Check if a specific date is blocked
    isDateBlocked = (date) => {
        return this.state.holidayBlockedDates.some(bd => bd.date === date);
    };

    // Find jobs scheduled on specific dates
    getJobsOnDates = (dates) => {
        const { calendarDays } = this.state;
        const dateSet = new Set(dates);

        return calendarDays.filter(job => {
            const jobDate = moment(job.workDate).format('YYYY-MM-DD');
            return dateSet.has(jobDate);
        });
    };

    // Format job info for warning message
    formatJobWarning = (jobs) => {
        if (jobs.length === 0) return null;

        const jobDescriptions = jobs.slice(0, 5).map(job => {
            const service = `${job.category} - ${job.description}`.trim();
            const vehicle = `${job.year} ${job.make} ${job.model}`.trim();
            const customer = job.dealerName || 'Customer';
            return `• ${service} on ${vehicle} for ${customer}`;
        }).join('\n');

        let message = `${jobs.length} job${jobs.length > 1 ? 's are' : ' is'} already scheduled:\n\n${jobDescriptions}`;

        if (jobs.length > 5) {
            message += `\n... and ${jobs.length - 5} more`;
        }

        message += '\n\nBlock this day anyway? Existing jobs will not be affected.';

        return message;
    };

    // Toggle a holiday block
    handleToggleHoliday = async (date, holidayName) => {
        const isCurrentlyBlocked = this.isDateBlocked(date);

        // If blocking (not unblocking), check for scheduled jobs
        if (!isCurrentlyBlocked) {
            const affectedJobs = this.getJobsOnDates([date]);
            if (affectedJobs.length > 0) {
                const warning = this.formatJobWarning(affectedJobs);
                if (!window.confirm(warning)) {
                    return; // User cancelled
                }
            }
        }

        try {
            this.setState({ holidaysLoading: true });
            await LocationService.toggleHoliday(this.state.typeId, date, holidayName, isCurrentlyBlocked);
            await this.loadBlockedDates();
            this.setState({ holidaysLoading: false });
        } catch (error) {
            console.error('Error toggling holiday:', error);
            alert('Failed to update holiday. Please try again.');
            this.setState({ holidaysLoading: false });
        }
    };

    // ---- Custom Closures Modal Methods ----
    handleOpenCustomClosuresModal = () => {
        this.setState({
            showCustomClosuresModal: true,
            newClosureStart: '',
            newClosureEnd: '',
            newClosureReason: ''
        });
    };

    handleCloseCustomClosuresModal = () => {
        this.setState({ showCustomClosuresModal: false });
    };

    handleAddCustomClosure = async () => {
        const { newClosureStart, newClosureEnd, newClosureReason } = this.state;

        if (!newClosureStart || !newClosureEnd || !newClosureReason.trim()) {
            alert('Please fill in all fields.');
            return;
        }

        if (moment(newClosureEnd).isBefore(moment(newClosureStart))) {
            alert('End date must be on or after start date.');
            return;
        }

        // Build list of dates in the range
        const datesToBlock = [];
        const current = moment(newClosureStart);
        const end = moment(newClosureEnd);
        while (current.isSameOrBefore(end)) {
            datesToBlock.push(current.format('YYYY-MM-DD'));
            current.add(1, 'day');
        }

        // Check for scheduled jobs in this range
        const affectedJobs = this.getJobsOnDates(datesToBlock);
        if (affectedJobs.length > 0) {
            const warning = this.formatJobWarning(affectedJobs);
            if (!window.confirm(warning)) {
                return; // User cancelled
            }
        }

        try {
            this.setState({ closuresLoading: true });
            await LocationService.addDateRange(
                this.state.typeId,
                newClosureStart,
                newClosureEnd,
                newClosureReason.trim()
            );
            await this.loadBlockedDates();
            this.setState({
                closuresLoading: false,
                newClosureStart: '',
                newClosureEnd: '',
                newClosureReason: ''
            });
        } catch (error) {
            console.error('Error adding custom closure:', error);
            alert('Failed to add closure. Please try again.');
            this.setState({ closuresLoading: false });
        }
    };

    handleRemoveClosure = async (closure) => {
        if (!window.confirm(`Remove closure "${closure.reason}" from ${this.formatDateRange(closure.start_date, closure.end_date)}?`)) {
            return;
        }

        try {
            this.setState({ closuresLoading: true });
            await LocationService.removeDateRange(this.state.typeId, closure.start_date, closure.end_date);
            await this.loadBlockedDates();
            this.setState({ closuresLoading: false });
        } catch (error) {
            console.error('Error removing closure:', error);
            alert('Failed to remove closure. Please try again.');
            this.setState({ closuresLoading: false });
        }
    };

    render() {
        const { isDesktop, calendarDays, isBulkSyncing, error, loading } = this.state;
        // Handle error state
        if (error) {
            return (
                <div className="calendar-container">
                    <div className="error-message">
                        <h3>Error Loading Calendar</h3>
                        <p>{error}</p>
                        <button onClick={() => window.location.reload()}>Refresh Page</button>
                    </div>
                </div>
            );
        }

        // Filter and prepare display data - Use the extracted method
        let displayWorkTable = this.buildDisplayWorkTable();

        // Calculate job service counts and positions
        const jobServiceCounts = {};
        calendarDays.forEach(appointment => {
            if (!jobServiceCounts[appointment.requestId]) {
                jobServiceCounts[appointment.requestId] = new Set();
            }
            jobServiceCounts[appointment.requestId].add(appointment.serviceId);
        });

        // Add service position info to display items
        displayWorkTable = displayWorkTable.map(item => {
            const totalServicesInJob = jobServiceCounts[item.requestId]?.size || 1;
            
            // Get all services for this job and sort by start date to determine order
            const jobServices = calendarDays
                .filter(appt => appt.requestId === item.requestId)
                .reduce((acc, appt) => {
                    // Only add each service once (avoid duplicates from multi-day services)
                    if (!acc.find(s => s.serviceId === appt.serviceId)) {
                        acc.push({
                            serviceId: appt.serviceId,
                            workDate: appt.workDate
                        });
                    }
                    return acc;
                }, [])
                .sort((a, b) => new Date(a.workDate) - new Date(b.workDate)); // Sort by start date
            
            const currentServicePosition = jobServices.findIndex(s => s.serviceId === item.serviceId) + 1;
            
            return {
                ...item,
                totalServicesInJob,
                currentServiceNumber: currentServicePosition
            };
        });
        
        // Calculate metrics based on VISIBLE data only
        const visibleJobCount = this.getVisibleJobCount(displayWorkTable);
        const visibleRevenue = this.getVisibleRevenue(displayWorkTable); // Now includes discount subtraction
        const visibleCapacity = this.getVisibleCapacityUtilization(displayWorkTable);
const visibleUnsyncedCount = displayWorkTable.filter(job => 
    !job.isInCalendar && moment(job.startDate).isSameOrAfter(moment().startOf('day'))
).length;
        // Update display string with visible service count (not job count)
        const totalVisibleServices = displayWorkTable.length;
        const displayStringWithCount = this.getDisplayString(
            moment(this.state.selectedDate || this.state.today), 
            this.state.range, 
            totalVisibleServices
        ).replace(' job', ' service'); // Change "jobs" to "services" in the display

        // Task overlay chips — merged AFTER the metrics above so tasks never
        // affect job count, revenue, capacity, or unsynced numbers.
        displayWorkTable = displayWorkTable.concat(this.buildTaskChips());

        // Get unique days for card display
        let uniqueDays = displayWorkTable.map(i => i.startDateString);
        const uniques = Array.from(new Set(uniqueDays));

        // Get blocked periods (holidays + custom closures) that overlap with visible range
        const startDate = moment(this.state.startDate || this.state.today).startOf("day");
        const endDate = moment(this.state.endDate || startDate).endOf("day");
        const blockedPeriodsInRange = [];

        // Add holidays as single-day periods
        this.state.holidayBlockedDates.forEach(bd => {
            const bdMoment = moment.utc(bd.date).local();
            if (bdMoment.isBetween(startDate, endDate, null, '[]')) {
                blockedPeriodsInRange.push({
                    start_date: bd.date,
                    end_date: bd.date,
                    reason: bd.reason,
                    type: 'holiday'
                });
            }
        });

        // Add custom closures (already grouped as date ranges)
        this.state.customClosures.forEach(closure => {
            const closureStart = moment.utc(closure.start_date).local();
            const closureEnd = moment.utc(closure.end_date).local();
            // Check if closure overlaps with visible range
            if (closureStart.isSameOrBefore(endDate) && closureEnd.isSameOrAfter(startDate)) {
                blockedPeriodsInRange.push({
                    start_date: closure.start_date,
                    end_date: closure.end_date,
                    reason: closure.reason,
                    type: 'closure'
                });
            }
        });

        // Add closed weekdays from operating hours
        if (this.state.operatingHours.length > 0) {
            const closedDays = this.state.operatingHours.filter(h => !h.is_open).map(h => h.day_of_week);
            if (closedDays.length > 0) {
                let cursor = moment(startDate);
                while (cursor.isSameOrBefore(endDate, 'day')) {
                    if (closedDays.includes(cursor.day())) {
                        const dateStr = cursor.format('YYYY-MM-DD');
                        // Don't duplicate if already blocked by holiday/closure
                        const alreadyBlocked = blockedPeriodsInRange.some(p => dateStr >= p.start_date && dateStr <= p.end_date);
                        if (!alreadyBlocked) {
                            blockedPeriodsInRange.push({
                                start_date: dateStr,
                                end_date: dateStr,
                                reason: '',
                                type: 'hours'
                            });
                        }
                    }
                    cursor.add(1, 'day');
                }
            }
        }

        // Sort blocked periods by start date
        blockedPeriodsInRange.sort((a, b) => a.start_date.localeCompare(b.start_date));

        return (
            <React.Fragment>
                <div className={`calendar-container ${isDesktop ? 'desktop' : 'mobile'}`}>
                    {/* Header */}
                    <div className="calendar-header">
                        <div className="header-content">
                            <div className="header-nav">
                                {isDesktop && (
                                    <div className="view-toggle">
                                        <button 
                                            className={this.state.range === "day" ? "active" : ""}
                                            onClick={this.handleRange} 
                                            value="day"
                                        >
                                            Day
                                        </button>
                                        <button 
                                            className={this.state.range === "week" ? "active" : ""}
                                            onClick={this.handleRange} 
                                            value="week"
                                        >
                                            Week
                                        </button>
                                        <button 
                                            className={this.state.range === "month" ? "active" : ""}
                                            onClick={this.handleRange} 
                                            value="month"
                                        >
                                            Month
                                        </button>
                                    </div>
                                )}
                                <div className="date-display">
                                    {displayStringWithCount}
                                </div>
                                <ButtonGroup className="nav-controls">
                                    <Button variant="outline-secondary" onClick={this.handleDisplayRange} value="less">
                                        ←
                                    </Button>
                                    <Button 
                                        variant="outline-secondary" 
                                        onClick={this.handleDisplayRange} 
                                        value="today"
                                        active={moment(this.state.selectedDate).isSame(this.state.today, 'day')}
                                    >
                                        Today
                                    </Button>
                                    <Button variant="outline-secondary" onClick={this.handleDisplayRange} value="more">
                                        →
                                    </Button>
                                </ButtonGroup>
                                <Link to="/newestimate/" className="btn btn-primary new-estimate-btn">
                                    + New Estimate
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Overview Dashboard */}
                    <div className="overview-cards">
                        <div className="overview-card">
                            <div className="number">{visibleJobCount}</div>
                            <div className="label">Jobs This Period</div>
                        </div>
                        <div className="overview-card">
                            <div className="number">{visibleCapacity}%</div>
                            <div className="label">Capacity Used</div>
                        </div>
                        {isDesktop && (
                            <div className="overview-card">
                                <div className="number">${visibleRevenue.toFixed(0)}</div>
                                <div className="label">{this.getPeriodRevenueLabel()}</div>
                            </div>
                        )}
                    </div>

{/* Quick Actions (Desktop Only) */}
{isDesktop && (
    <div className="bulk-actions">
        <div className="label">Quick Actions:</div>

        {/* Calendar Connection & Sync - only at location level (calendars are per-location) */}
        {this.props.selectedLocationId && this.props.selectedLocationId !== 'all' && (
          <>
<div className="calendar-connection-actions">
  {this.state.isCalendarConnected ? (
    <>
      <button
        className="action-btn connect-btn"
        onClick={this.disconnectCalendar}
        title="Disconnect Google Calendar"
      >
        <i className="fa-sharp fa-regular fa-link-slash mr-1"></i> Disconnect Calendar
      </button>

      {/* Sync Actions (only show if connected) */}
      {visibleUnsyncedCount > 0 ? (
        <button
          className="bulk-sync-btn"
          onClick={this.handleBulkSync}
          disabled={isBulkSyncing}
        >
          {isBulkSyncing ? (
            <><i className="fa-sharp fa-regular fa-spinner fa-spin mr-1"></i> Syncing...</>
          ) : (
            <><i className="fa-sharp fa-regular fa-calendar-check mr-1"></i> Sync All to Calendar ({visibleUnsyncedCount} services)</>
          )}
        </button>
      ) : (
        <span className="sync-status">All jobs synced to calendar</span>
      )}
    </>
  ) : (
    <>
      <button
        className="action-btn connect-btn"
        onClick={this.connectCalendar}
      >
        <i className="fa-sharp fa-regular fa-link mr-1"></i> Connect Google Calendar
      </button>
      {this.state.calendarConnectionError && (
        <div className="connection-error">
          {this.state.calendarConnectionError}
        </div>
      )}
    </>
  )}
</div>

        {/* Calendar Selection Modal */}
{this.state.showCalendarSelection && (
  <CalendarSelectionModal
    calendars={this.state.availableCalendars}
    installerId={this.state.typeId}
    onSelect={this.handleCalendarSelection}
    onCancel={() => this.setState({ showCalendarSelection: false, availableCalendars: [] })}
  />
)}
          </>
        )}

        {/* Export Action - available at all levels */}
        {this.state.range === "week" ? (
            <button
                className="action-btn export-btn"
                onClick={this.exportWeekSchedule}
                title="Export current week as PDF"
                disabled={loading}
            >
                {loading ? (
                    <><i className="fa-sharp fa-regular fa-spinner fa-spin mr-1"></i> Generating...</>
                ) : (
                    <><i className="fa-sharp fa-regular fa-file-export mr-1"></i> Export Week</>
                )}
            </button>
        ) : (
            <button
                className="action-btn disabled"
                disabled
                title="Export is only available in Week view"
            >
                <i className="fa-sharp fa-regular fa-file-export mr-1"></i> Export Week
            </button>
        )}

        {/* Holidays & Closures Actions - only at location level */}
        {this.props.selectedLocationId && this.props.selectedLocationId !== 'all' && (
          <>
            <button
                className="action-btn"
                onClick={this.handleOpenHolidaysModal}
                title="Manage holiday closures"
            >
                <i className="fa-sharp fa-regular fa-calendar-star mr-1"></i> Manage Holidays
            </button>
            <button
                className="action-btn"
                onClick={this.handleOpenCustomClosuresModal}
                title="Manage custom closures"
            >
                <i className="fa-sharp fa-regular fa-calendar-xmark mr-1"></i> Custom Closures
            </button>
          </>
        )}
    </div>
)}

                    {/* Filters & View Controls — single row: dropdown | toggles | key */}
                    <div className="filters-section">
                        <div className="filter-controls" style={{ alignItems: 'center' }}>
                            {/* Technician filter dropdown with color dots */}
                            {this.state.hasTechnicians && (
                                <>
                                    <div className="filter-group" style={{ minWidth: 160, maxWidth: 200, position: 'relative' }}>
                                        <div
                                            className="form-control"
                                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}
                                            onClick={() => this.setState(prev => ({ showTechDropdown: !prev.showTechDropdown }))}
                                        >
                                            {(() => {
                                                if (this.state.selectedTechnician === 'All Technicians') return <span style={{ color: 'var(--color-text-secondary)' }}>All Technicians</span>;
                                                const t = (this.state.allStaff || []).find(s => (s.user_name || s.Email) === this.state.selectedTechnician);
                                                return (
                                                    <>
                                                        {t?.user_color && <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: t.user_color, flexShrink: 0 }} />}
                                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{this.state.selectedTechnician}</span>
                                                    </>
                                                );
                                            })()}
                                            <i className="fa-sharp fa-regular fa-chevron-down" style={{ fontSize: 10, marginLeft: 'auto', color: 'var(--color-text-muted)' }} />
                                        </div>
                                        {this.state.showTechDropdown && (
                                            <div style={{
                                                position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 2,
                                                background: 'var(--color-bg-card)', border: '1px solid var(--color-border)', borderRadius: 6,
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.12)', zIndex: 100, maxHeight: 240, overflowY: 'auto',
                                            }}>
                                                {this.state.technicianOptions.map(opt => {
                                                    const tech = opt !== 'All Technicians' ? (this.state.allStaff || []).find(s => (s.user_name || s.Email) === opt) : null;
                                                    const isActive = this.state.selectedTechnician === opt;
                                                    return (
                                                        <div
                                                            key={opt}
                                                            onClick={() => this.setState({ selectedTechnician: opt, showTechDropdown: false })}
                                                            style={{
                                                                padding: '8px 12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
                                                                background: isActive ? 'var(--color-brand-teal-light)' : 'transparent', fontSize: 13,
                                                            }}
                                                            onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = 'var(--color-bg-panel)'; }}
                                                            onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
                                                        >
                                                            <span style={{
                                                                width: 10, height: 10, borderRadius: '50%', flexShrink: 0,
                                                                background: tech?.user_color || 'var(--color-bg-inset)',
                                                                border: !tech?.user_color ? '1px dashed var(--color-border-strong)' : 'none',
                                                            }} />
                                                            <span>{opt}</span>
                                                            {isActive && <i className="fa-sharp fa-solid fa-check" style={{ fontSize: 10, color: 'var(--color-brand-teal)', marginLeft: 'auto' }} />}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                    {this.state.selectedTechnician !== "All Technicians" && (
                                        <button
                                            className="btn btn-link p-0 clear-filter-btn"
                                            onClick={() => this.setState({ selectedTechnician: "All Technicians" })}
                                            type="button"
                                        >
                                            CLEAR
                                        </button>
                                    )}
                                </>
                            )}

                            {/* Spacer pushes toggles to center */}
                            <div style={{ flex: 1 }} />

                            {/* View Mode Toggle (Cards/Grid) — desktop only */}
                            {isDesktop && (
                                <div className="view-mode-toggle">
                                    <button
                                        className={this.state.viewMode === 'cards' ? 'active' : ''}
                                        onClick={() => this.setState({ viewMode: 'cards' })}
                                        title="Card View"
                                    >
                                        <i className="fa-sharp fa-regular fa-rectangle-vertical-history" />
                                        Cards
                                    </button>
                                    <button
                                        className={this.state.viewMode === 'grid' ? 'active' : ''}
                                        onClick={() => this.setState({ viewMode: 'grid' })}
                                        title="Grid View"
                                    >
                                        <i className="fa-sharp fa-regular fa-calendar-days" />
                                        Grid
                                    </button>
                                </div>
                            )}

                            {/* Color Mode Toggle (Stage/Tech) — only show if any tech has a color set */}
                            {(this.state.allStaff || []).some(t => t.user_color) && (
                                <div className="view-mode-toggle">
                                    <button
                                        className={this.state.calendarColorMode === 'stage' ? 'active' : ''}
                                        onClick={() => this.handleColorModeToggle('stage')}
                                        title="Color by stage"
                                    >
                                        <i className="fa-sharp fa-regular fa-layer-group" />
                                        Stage
                                    </button>
                                    <button
                                        className={this.state.calendarColorMode === 'technician' ? 'active' : ''}
                                        onClick={() => this.handleColorModeToggle('technician')}
                                        title="Color by technician"
                                    >
                                        <i className="fa-sharp fa-regular fa-user" />
                                        Tech
                                    </button>
                                </div>
                            )}

                            {/* Spacer pushes key to right */}
                            <div style={{ flex: 1 }} />

                            {/* Inline color key — same line, right side */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                {this.state.calendarColorMode === 'stage' ? (
                                    <>
                                        {Object.keys(DEFAULT_STAGE_COLORS).map(stage => {
                                            const color = this.state.stageColors[stage] || DEFAULT_STAGE_COLORS[stage];
                                            const canEdit = ['admin', 'owner', 'manager'].includes(
                                                (ScopeService.getUserRole() || '').toLowerCase()
                                            );
                                            return (
                                                <div key={stage} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                    {canEdit ? (
                                                        <ColorPicker
                                                            selectedColor={color}
                                                            onSelect={(c) => this.handleStageColorChange(stage, c)}
                                                            onClear={() => this.handleStageColorChange(stage, null)}
                                                        />
                                                    ) : (
                                                        <span style={{ width: 10, height: 10, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }} />
                                                    )}
                                                    <span style={{ fontSize: 12, color: 'var(--color-text-primary)', textTransform: 'capitalize' }}>{stage}</span>
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : (
                                    <>
                                        {(this.state.allStaff || []).filter(s => s.user_color).map(s => (
                                            <div key={s.User_id} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                <span style={{ width: 10, height: 10, borderRadius: '50%', background: s.user_color, display: 'inline-block', flexShrink: 0 }} />
                                                <span style={{ fontSize: 12, color: 'var(--color-text-primary)' }}>{s.user_name || s.Email}</span>
                                            </div>
                                        ))}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                            <span style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--color-text-muted)', display: 'inline-block', flexShrink: 0 }} />
                                            <span style={{ fontSize: 12, color: 'var(--color-text-primary)' }}>Unassigned</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Calendar Content — Grid or Cards */}
                    {this.state.viewMode === 'grid' && isDesktop && moment.isMoment(this.state.startDate) ? (
                        <CalendarGrid
                            range={this.state.range}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            displayWorkTable={displayWorkTable}
                            blockedPeriodsInRange={blockedPeriodsInRange}
                            locations={this.props.locations}
                            selectedLocationId={this.props.selectedLocationId}
                            onDisplayDetails={this.displayDetails}
                            onTaskClick={this.handleTaskClick}
                            calendarDays={this.state.calendarDays}
                            colorMode={this.state.calendarColorMode}
                            stageColors={this.state.stageColors}
                            technicians={this.state.allStaff}
                            selectedTechnician={this.state.selectedTechnician}
                        />
                    ) : (
                        <div className={`calendar-grid ${isDesktop ? 'desktop-grid' : 'mobile-grid'}`}>
                            {/* Blocked periods (holidays & closures) */}
                            {blockedPeriodsInRange.map((period, index) => {
                                const isSingleDay = period.start_date === period.end_date;
                                // Server may serialize as "YYYY-MM-DD" or "YYYY-MM-DDT00:00:00Z".
                                // Calendar-date semantic regardless — render the date portion
                                // in UTC so HST/PST don't shift the label to the previous day.
                                const fmt = (d) => moment.utc(d).format('ddd, MMM D');
                                const dateDisplay = isSingleDay
                                    ? fmt(period.start_date)
                                    : `${fmt(period.start_date)} - ${fmt(period.end_date)}`;

                                return (
                                    <div
                                        className="blocked-date-card clickable"
                                        key={`blocked-${index}`}
                                        onClick={() => period.type === 'holiday'
                                            ? this.handleOpenHolidaysModal()
                                            : this.handleOpenCustomClosuresModal()
                                        }
                                        title="Click to manage"
                                    >
                                        <div className="blocked-date-header">
                                            <span className="blocked-date-icon">
                                                {period.type === 'holiday' ? '🎄' : '🚫'}
                                            </span>
                                            <span className="blocked-date-title">{dateDisplay}</span>
                                        </div>
                                        <div className="blocked-date-reason">
                                            <strong>CLOSED</strong> — {period.reason}
                                        </div>
                                        <div className="blocked-date-hint">
                                            Click to manage
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Job cards */}
                            {uniques.map((dateString, index) => {
                                const cardIsExpanded = this.state.expandedCards.has(dateString);

                                return (
                                    <CalendarCard
                                        key={dateString}
                                        date={dateString}
                                        workTable={displayWorkTable}
                                        onDisplayDetails={this.displayDetails}
                                        onTaskClick={this.handleTaskClick}
                                        isDesktop={isDesktop}
                                        isExpanded={cardIsExpanded}
                                        onCardExpansion={this.handleCardExpansion}
                                        locations={this.props.locations}
                                        selectedLocationId={this.props.selectedLocationId}
                                        colorMode={this.state.calendarColorMode}
                                        stageColors={this.state.stageColors}
                                        technicians={this.state.allStaff}
                                        selectedTechnician={this.state.selectedTechnician}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>

                {/* Job Details Modal */}
                <ViewJob
                    show={this.state.showDetails}
                    onHide={this.addCustomClose}
                    request={this.state.selectedRequestimate}
                    services={this.state.services}
                    notes={this.state.notes}
                />

                {/* Task chip detail — complete/snooze in place */}
                <TaskActionModal
                    show={!!this.state.calendarTaskModal}
                    onHide={() => this.setState({ calendarTaskModal: null })}
                    task={this.state.calendarTaskModal}
                    user={ScopeService.getUser() || {}}
                    onActionComplete={this.handleTaskActionComplete}
                />

                {/* Holidays Modal */}
                <Modal show={this.state.showHolidaysModal} onHide={this.handleCloseHolidaysModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Holiday Closures</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-muted mb-4">
                            Select holidays when your shop will be closed. Changes are saved immediately.
                        </p>

                        {this.state.holidaysLoading && (
                            <div className="text-center mb-3">
                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        )}

                        {/* Current Year Holidays - only show future holidays */}
                        {(() => {
                            const today = moment().startOf('day');
                            const currentYear = moment().year();
                            const currentYearHolidays = US_HOLIDAYS.filter(holiday => {
                                const date = holiday.getDate(currentYear);
                                return moment(date).isSameOrAfter(today);
                            });

                            if (currentYearHolidays.length === 0) return null;

                            return (
                                <>
                                    <h6 className="mb-3">{currentYear} Holidays</h6>
                                    <div className="holiday-checklist mb-4">
                                        {currentYearHolidays.map(holiday => {
                                            const date = holiday.getDate(currentYear);
                                            const isBlocked = this.isDateBlocked(date);
                                            return (
                                                <div className="holiday-item d-flex align-items-center py-2 border-bottom" key={`${holiday.id}-${currentYear}`}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id={`holiday-${holiday.id}-${currentYear}`}
                                                            checked={isBlocked}
                                                            onChange={() => this.handleToggleHoliday(date, holiday.name)}
                                                            disabled={this.state.holidaysLoading}
                                                        />
                                                        <label className="custom-control-label" htmlFor={`holiday-${holiday.id}-${currentYear}`}>
                                                            <strong>{holiday.name}</strong>
                                                            <span className="text-muted ml-2">{formatHolidayDate(date)}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            );
                        })()}

                        {/* Next Year Holidays - only show future holidays */}
                        {(() => {
                            const today = moment().startOf('day');
                            const nextYear = moment().year() + 1;
                            const nextYearHolidays = US_HOLIDAYS.filter(holiday => {
                                const date = holiday.getDate(nextYear);
                                return moment(date).isSameOrAfter(today);
                            });

                            if (nextYearHolidays.length === 0) return null;

                            return (
                                <>
                                    <h6 className="mb-3">{nextYear} Holidays</h6>
                                    <div className="holiday-checklist">
                                        {nextYearHolidays.map(holiday => {
                                            const date = holiday.getDate(nextYear);
                                            const isBlocked = this.isDateBlocked(date);
                                            return (
                                                <div className="holiday-item d-flex align-items-center py-2 border-bottom" key={`${holiday.id}-${nextYear}`}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id={`holiday-${holiday.id}-${nextYear}`}
                                                            checked={isBlocked}
                                                            onChange={() => this.handleToggleHoliday(date, holiday.name)}
                                                            disabled={this.state.holidaysLoading}
                                                        />
                                                        <label className="custom-control-label" htmlFor={`holiday-${holiday.id}-${nextYear}`}>
                                                            <strong>{holiday.name}</strong>
                                                            <span className="text-muted ml-2">{formatHolidayDate(date)}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            );
                        })()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseHolidaysModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Custom Closures Modal */}
                <Modal show={this.state.showCustomClosuresModal} onHide={this.handleCloseCustomClosuresModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Custom Closures</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-muted mb-4">
                            Block date ranges for vacations, training, or other closures.
                        </p>

                        {/* Add New Closure Form */}
                        <div className="card p-3 mb-4 bg-light">
                            <h6 className="mb-3">Add New Closure</h6>
                            <div className="form-row align-items-end">
                                <div className="col-md-3">
                                    <label className="small font-weight-bold">From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={this.state.newClosureStart}
                                        onChange={(e) => this.setState({ newClosureStart: e.target.value })}
                                        min={moment().format('YYYY-MM-DD')}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="small font-weight-bold">To</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={this.state.newClosureEnd}
                                        onChange={(e) => this.setState({ newClosureEnd: e.target.value })}
                                        min={this.state.newClosureStart || moment().format('YYYY-MM-DD')}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="small font-weight-bold">Reason</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g., Vacation, Training"
                                        value={this.state.newClosureReason}
                                        onChange={(e) => this.setState({ newClosureReason: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <button
                                        className="btn btn-primary w-100"
                                        onClick={this.handleAddCustomClosure}
                                        disabled={!this.state.newClosureStart || !this.state.newClosureEnd || !this.state.newClosureReason || this.state.closuresLoading}
                                    >
                                        {this.state.closuresLoading ? 'Adding...' : 'Add'}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Existing Custom Closures List */}
                        <h6 className="mb-3">Scheduled Closures</h6>
                        {this.state.customClosures.length === 0 ? (
                            <p className="text-muted">No custom closures scheduled.</p>
                        ) : (
                            <div className="closures-list">
                                {this.state.customClosures.map((closure, idx) => (
                                    <div className="closure-item d-flex justify-content-between align-items-center p-3 border-bottom" key={idx}>
                                        <div>
                                            <strong>{this.formatDateRange(closure.start_date, closure.end_date)}</strong>
                                            <span className="text-muted ml-2">— {closure.reason}</span>
                                        </div>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => this.handleRemoveClosure(closure)}
                                            disabled={this.state.closuresLoading}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseCustomClosuresModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <style>{`
                    .calendar-container {
                        max-width: 1400px;
                        margin: 0 auto;
                        padding: 24px;
                        background: var(--color-bg-panel);
                        min-height: 100vh;
                    }

                    .calendar-container.mobile {
                        padding: 16px;
                    }

                    .error-message {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-danger-light);
                        border-radius: 8px;
                        padding: 24px;
                        text-align: center;
                        color: var(--color-danger);
                    }

                    .error-message button {
                        background: var(--color-danger);
                        color: var(--color-text-inverse);
                        border: none;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                        margin-top: 12px;
                    }

                    .calendar-header {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 24px;
                        margin-bottom: 24px;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .mobile .calendar-header {
                        padding: 16px;
                        margin-bottom: 16px;
                    }

                    .header-content {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 16px;
                    }

                    .mobile .header-content {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .header-nav {
                        display: flex;
                        align-items: center;
                        gap: 16px;
                        flex-wrap: wrap;
                        width: 100%;
                        justify-content: space-between;
                    }

                    .mobile .header-nav {
                        justify-content: space-between;
                    }

                    .view-toggle {
                        display: flex;
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 6px;
                        overflow: hidden;
                    }

                    .view-toggle button {
                        background: var(--color-bg-card);
                        border: none;
                        padding: 8px 16px;
                        font-size: 13px;
                        font-weight: 500;
                        color: var(--color-text-secondary);
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .view-toggle button:hover {
                        background: var(--color-bg-panel);
                    }

                    .view-toggle button.active {
                        background: var(--color-brand-teal);
                        color: var(--color-text-inverse);
                    }

                    .date-display {
                        font-size: 16px;
                        font-weight: 500;
                        color: var(--color-text-primary);
                        padding: 0 16px;
                    }

                    .mobile .date-display {
                        text-align: center;
                        padding: 8px 0;
                        order: -1;
                    }

                    .new-estimate-btn {
                        background: var(--color-brand-teal) !important;
                        border-color: var(--color-brand-teal) !important;
                        font-weight: 600;
                        text-decoration: none;
                    }

                    .new-estimate-btn:hover {
                        background: var(--color-brand-teal-hover) !important;
                        border-color: var(--color-brand-teal-hover) !important;
                        text-decoration: none;
                    }

                    .overview-cards {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 16px;
                        margin-bottom: 24px;
                    }

                    .mobile .overview-cards {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 12px;
                        margin-bottom: 16px;
                    }

                    .overview-card {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 20px;
                        text-align: center;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .mobile .overview-card {
                        padding: 16px 12px;
                    }

                    .overview-card .number {
                        font-size: 28px;
                        font-weight: 700;
                        color: var(--color-text-primary);
                        margin-bottom: 4px;
                    }

                    .mobile .overview-card .number {
                        font-size: 20px;
                    }

                    .overview-card .label {
                        font-size: 12px;
                        color: var(--color-text-secondary);
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .overview-card.urgent .number {
                        color: var(--color-danger);
                    }

                    .bulk-actions {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 16px;
                        margin-bottom: 24px;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                        position: relative;
                    }

                    .bulk-actions .label {
                        font-size: 14px;
                        font-weight: 500;
                        color: var(--color-text-primary);
                    }

                    .calendar-connection-actions {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                    }

                    .calendar-sync-actions {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                    }

                    .connect-btn {
                        background: var(--color-brand-teal) !important;
                        color: var(--color-text-inverse) !important;
                        border-color: var(--color-brand-teal) !important;
                    }

                    .connect-btn:hover {
                        background: var(--color-brand-teal-hover) !important;
                        border-color: var(--color-brand-teal-hover) !important;
                    }

                    .connection-error {
                        color: var(--color-danger-dark);
                        font-size: 12px;
                        background: var(--color-danger-light);
                        padding: 4px 8px;
                        border-radius: 4px;
                        border: 1px solid var(--color-danger-light);
                    }

                    .bulk-sync-btn {
                        background: var(--color-brand-teal);
                        color: var(--color-text-inverse);
                        border: none;
                        padding: 8px 16px;
                        border-radius: 6px;
                        font-size: 13px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .bulk-sync-btn:hover:not(:disabled) {
                        background: var(--color-brand-teal-hover);
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(63, 178, 190, 0.3);
                    }

                    .bulk-sync-btn:disabled {
                        opacity: 0.6;
                        cursor: not-allowed;
                        transform: none;
                    }

                    .action-btn {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        color: var(--color-text-secondary);
                        padding: 8px 16px;
                        border-radius: 6px;
                        font-size: 13px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .action-btn:hover:not(:disabled) {
                        border-color: var(--color-border);
                        background: var(--color-bg-panel);
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    }

                    .sync-status {
                        color: var(--color-success-dark);
                        font-size: 13px;
                        font-weight: 500;
                        padding: 8px 16px;
                        background: var(--color-success-light);
                        border-radius: 6px;
                    }

                    .calendar-grid.desktop-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
                        gap: 20px;
                    }

                    .calendar-grid.mobile-grid {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }

                    /* Blocked Date Card Styles */
                    .blocked-date-card {
                        background: linear-gradient(135deg, var(--color-warning-light) 0%, var(--color-warning-light) 100%);
                        border: 2px solid var(--color-warning);
                        border-radius: 8px;
                        padding: 16px;
                        box-shadow: 0 2px 4px rgba(245, 158, 11, 0.2);
                    }

                    .blocked-date-card.clickable {
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .blocked-date-card.clickable:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
                        border-color: var(--color-brand-orange-hover);
                    }

                    .blocked-date-header {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 8px;
                    }

                    .blocked-date-icon {
                        font-size: 20px;
                    }

                    .blocked-date-title {
                        font-size: 14px;
                        font-weight: 600;
                        color: var(--color-warning-dark);
                    }

                    .blocked-date-reason {
                        font-size: 14px;
                        color: var(--color-warning-dark);
                    }

                    .blocked-date-reason strong {
                        color: var(--color-warning-dark);
                    }

                    .blocked-date-hint {
                        font-size: 11px;
                        color: var(--color-warning-dark);
                        margin-top: 8px;
                        opacity: 0.7;
                    }

                    .blocked-date-card.clickable:hover .blocked-date-hint {
                        opacity: 1;
                    }

                    .export-btn {
                        background: var(--color-success) !important;
                        color: var(--color-text-inverse) !important;
                        border-color: var(--color-success) !important;
                    }

                    .export-btn:hover:not(:disabled) {
                        background: var(--color-success) !important;
                        border-color: var(--color-success) !important;
                        color: var(--color-text-inverse) !important;
                    }

                    .action-btn.disabled {
                        background: var(--color-bg-panel) !important;
                        color: var(--color-text-muted) !important;
                        border-color: var(--color-border) !important;
                        cursor: not-allowed !important;
                    }

                    .action-btn.disabled:hover {
                        background: var(--color-bg-panel) !important;
                        color: var(--color-text-muted) !important;
                        border-color: var(--color-border) !important;
                        transform: none !important;
                        box-shadow: none !important;
                    }

                    /* Technician Filter Styles (following newFinancials pattern) */
                    .filters-section {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 16px 20px;
                        margin-bottom: 16px;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .filter-controls {
                        display: flex;
                        gap: 16px;
                        align-items: center;
                        flex-wrap: wrap;
                    }

                    .mobile .filter-controls {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 12px;
                    }

                    .filter-group {
                        min-width: 160px;
                    }

                    .filter-group .form-group {
                        margin-bottom: 0;
                    }

                    .filter-group label {
                        font-size: 14px;
                        font-weight: 500;
                        color: var(--color-text-primary);
                        margin-bottom: 4px;
                    }

                    .filter-group .form-control {
                        font-size: 14px;
                        padding: 8px 12px;
                        border: 1px solid var(--color-border);
                        border-radius: 6px;
                    }

                    .filter-group .form-control:focus {
                        border-color: var(--color-brand-teal);
                        box-shadow: 0 0 0 2px rgba(63, 178, 190, 0.1);
                    }

                    .clear-filter-btn {
                        font-size: 13px;
                        color: var(--color-text-secondary);
                        text-decoration: underline;
                    }

                    .clear-filter-btn:hover {
                        color: var(--color-text-primary);
                    }

                    @media (max-width: 768px) {
                        .calendar-grid.desktop-grid {
                            grid-template-columns: 1fr;
                            gap: 12px;
                        }
                    }
                        .calendar-connection-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.connection-status {
  font-size: 13px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  white-space: nowrap;
}

.connection-status:contains("✅") {
  color: var(--color-success-dark);
  background: var(--color-success-light);
}

.connection-status:contains("Not Connected") {
  color: var(--color-danger-dark);
  background: var(--color-danger-light);
}

.disconnect-btn {
  background: var(--color-danger) !important;
  color: var(--color-text-inverse) !important;
  border-color: var(--color-danger) !important;
}

.disconnect-btn:hover:not(:disabled) {
  background: var(--color-danger) !important;
  border-color: var(--color-danger) !important;
  color: var(--color-text-inverse) !important;
}

.connect-btn {
  background: var(--color-brand-teal) !important;
  color: var(--color-text-inverse) !important;
  border-color: var(--color-brand-teal) !important;
}

.connect-btn:hover:not(:disabled) {
  background: var(--color-brand-teal-hover) !important;
  border-color: var(--color-brand-teal-hover) !important;
}
                `}</style>
            </React.Fragment>
        );
    }
}
// Calendar Selection Modal Component (moved from navBar.jsx)
const CalendarSelectionModal = ({ calendars, installerId, onSelect, onCancel }) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  }} onClick={onCancel}>
    <div style={{
      backgroundColor: 'var(--color-bg-card)', borderRadius: '8px', padding: '30px',
      maxWidth: '550px', width: '90%', boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      maxHeight: '80vh', overflow: 'auto'
    }} onClick={e => e.stopPropagation()}>
      
      <div className="text-center mb-4">
        <h4>Select Your Business Calendar</h4>
        <p className="text-muted mb-2">
          Choose which Google Calendar to sync jobs for <strong>this location</strong>:
        </p>
      </div>
      
      <div style={{ maxHeight: '300px', overflow: 'auto' }}>
        {calendars.map((calendar, index) => (
          <div key={calendar.id} style={{
            border: '2px solid var(--color-border)',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '12px',
            cursor: 'pointer',
            backgroundColor: calendar.primary ? 'var(--color-info-light)' : 'var(--color-bg-card)',
            borderColor: calendar.primary ? 'var(--color-brand-teal)' : 'var(--color-border)',
            transition: 'all 0.2s ease'
          }} 
          onClick={() => onSelect(calendar)}
          onMouseEnter={(e) => {
            e.target.style.borderColor = 'var(--color-brand-teal)';
            e.target.style.backgroundColor = 'var(--color-bg-panel)';
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = calendar.primary ? 'var(--color-brand-teal)' : 'var(--color-border)';
            e.target.style.backgroundColor = calendar.primary ? 'var(--color-info-light)' : 'var(--color-bg-card)';
          }}>
            
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between' 
            }}>
              <div>
                <div style={{ 
                  fontWeight: '600', 
                  fontSize: '16px',
                  marginBottom: '4px',
                  color: 'var(--color-text-primary)'
                }}>
                  {calendar.name}
                </div>
              </div>
              
              <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: '2px solid var(--color-border)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {calendar.primary && (
                  <div style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: 'var(--color-brand-teal)',
                    borderRadius: '50%'
                  }} />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="text-center mt-4">
        <button 
          className="btn btn-outline-secondary btn-lg"
          onClick={onCancel}
          style={{ minWidth: '120px' }}
        >
          CANCEL SETUP
        </button>
        
      </div>
    </div>
  </div>
);

export default Calendar;